import { VehicleStatusCode } from "../../api/types/VehicleStatusCode";


export type StatusCodeFilter = VehicleStatusCode[] | null;

// a stable reference for "nothing filtered", so effects keyed on the filter
// don't re-run on a fresh literal each render
export const NO_STATUS_FILTER: StatusCodeFilter = null;

// the one place that decides whether a point gets a pin
export const statusCodeIsPinned = (
  filter: StatusCodeFilter | undefined,
  statusCode: VehicleStatusCode
) => !filter || filter.includes(statusCode);

// identity-independent effect key - callers rebuild the array on most
// renders, and `null` has to be distinguishable from `[]`
export const statusFilterKey = (filter: StatusCodeFilter | undefined) =>
  filter ? filter.join(",") : "all";
